import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RadioSelectedIcon = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            data-testid="icon-radioSelected"
        >
            <defs>
                <filter id="a" width="140%" height="140%" x="-20%" y="-10%" filterUnits="objectBoundingBox">
                    <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                </filter>
            </defs>
            <g fill="none">
                <path fill="#0070C8" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" />
                <g>
                    <circle fill="#000" cx="10" cy="10" r="5" filter="url(#a)"></circle>
                    <circle fill="#fff" cx="10" cy="10" r="4.7"></circle>
                </g>
            </g>
        </svg>
    );
};
